import { inject, Injectable } from '@angular/core';
import { StepResolverStrategy } from './step-resolver.strategy';
import { Step } from '../../types';
import { Observable, of } from 'rxjs';
import { QuoteStepDefinitionService } from '../step-definition';
import { Flow } from '@lx/quote-tool/lite/shared/types';

@Injectable({
  providedIn: 'root',
})
export class QuoteStepResolverService implements StepResolverStrategy {
  private readonly quoteStepDefinitionService = inject(QuoteStepDefinitionService);

  /**
   * It resolves the quote step by returning the
   * step definition for the active flow.
   * @param activeFlow
   */
  resolve(activeFlow: Flow): Observable<Step> {
    return of(this.quoteStepDefinitionService.getStepDefinition(activeFlow));
  }
}
